import React from 'react';
import { useFormContext } from 'react-hook-form';
import TextField from '../../../../../../../../Inputs/TextField';
import styles from '../../index.module.scss';
import classNames from 'classnames';
import useIntakeBlockToggle, { intakeBlocksEnum } from '../../../../../hooks/useIntakeBlockToggle';

const CaseNumberField = () => {
  const {
    register,
    clearErrors,
    formState: { errors },
  } = useFormContext();
  const { isRequired } = useIntakeBlockToggle();

  return (
    <TextField
      label="Case number"
      {...register('caseNumber', {
        required: isRequired(intakeBlocksEnum.emr)
          ? 'Please enter case number'
          : '',
      })}
      wrapperClassName={classNames(
        styles.inputWrapper,
        styles.lastField
      )}
      inputClassName={styles.inputField}
      error={!!errors?.caseNumber}
      helperText={errors?.caseNumber?.message}
      required={isRequired(intakeBlocksEnum.emr)}
      onInput={() => clearErrors('caseNumber')}
    />
  );
};
export default CaseNumberField;
